import { getImageUrl } from "@/lib/api";
export default function PageHeader({ eyebrow, title, description, image }) {
  return (
    <section className="relative pt-14 pb-16 md:pt-24 md:pb-24 overflow-hidden bg-gradient-to-br from-[#f8f5ee] via-white to-[#e7edfb]">
      <div className="grain-overlay opacity-30" />
      <div className="absolute -top-32 right-0 h-96 w-96 rounded-full" style={{ background: "radial-gradient(circle, rgba(242,140,31,.08) 0%, transparent 70%)" }} />
      <div className="absolute -bottom-32 left-0 h-96 w-96 rounded-full" style={{ background: "radial-gradient(circle, rgba(27,58,142,.08) 0%, transparent 70%)" }} />
      <div className="container-sf relative">
        <div className="grid lg:grid-cols-[1.4fr,1fr] gap-10 items-center">
          <div>
            {eyebrow && <div className="eyebrow mb-4">{eyebrow}</div>}
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-[1.05] tracking-tight text-slate-900">
              {title}
            </h1>
            {description && (
              <p className="mt-5 text-lg md:text-xl text-slate-600 leading-relaxed max-w-2xl whitespace-pre-wrap">
                {description}
              </p>
            )}
          </div>
          {image && (
            <div className="relative aspect-[4/3] rounded-3xl overflow-hidden shadow-xl bg-slate-100 hidden lg:block">
              <img src={getImageUrl(image)} alt="" className="w-full h-full object-cover" />
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
